import { useMainContext } from '../../core/contexts/main';
import { IoIosCloseCircle } from 'react-icons/io';
import Text from '../../core/utils/Text';
import { formatDate, formatNumber } from '../../core/utils/common';
import { Link } from 'react-router-dom';
import { FaCircle } from 'react-icons/fa';
import { BiChevronLeft, BiCopy } from 'react-icons/bi';
import { CgCopy } from 'react-icons/cg';
import { useCopyToClipboard } from '../../pages/wallet/utils/useCopyToClipboard';

export default function InternalTransferResult({ result, closeResult }) {
	const { data: resultData, success } = result;
	const {
		main: { lang },
	} = useMainContext();
	const { copyToClip } = useCopyToClipboard()

	return (
		<div className='flex flex-col w-full max-w-md mx-auto text-sm p-6 rounded-lg bg-white shadow-lg dark:bg-gray-800 text-white'>
			{/* Header */}
			<h2 className='text-center text-lg font-semibold text-gray-900 dark:text-white'>
				<Text tid='transfer-status' />
			</h2>

			{/* Status Icon */}
			<div className={`flex items-center flex-col border border-dashed my-4 rounded-2xl ${success ? 'border-active' : 'border-red-600'}`}>
				<div className='w-full flex justify-center py-7'>
					<img width={200} height={80} src={require(`../../assets/images/internal-transfer-${success ? 'success' : 'failed'}.png`)} alt='internal-transfer-success' />
				</div>

				{/* Status Message */}
				<h3 className={`text-center font-semibold my-2 ${success ? 'text-[#00A478]' : 'text-[#d33c3c]'}`}>
					{success ? <Text tid='successful-transfer' /> : <Text tid='failed-transfer' />}
				</h3>
				<p className={`text-center font-semibold my-2 text-gray-900 dark:text-white`}>
					{success ? <Text tid='successful-transfer-caption' /> : <Text tid='failed-transfer-caption' />}
				</p>

				{/* Details */}
				<div className='space-y-2 my-3 px-4'>
					<div className='flex flex-col justify-between items-start'>
						<span className='opacity-70 text-gray-900 dark:text-white'><Text tid='transfer-id' /></span>
						<div className='relative'>
							<input className='bg-white border border-[#3B3D48] dark:shadow-none dark:bg-[#3B3D48] rounded-lg text-gray-900 dark:text-[#B0C1FF] outline-none w-full max-w-[320px] sm:max-w-full h-[50px] px-3 truncate pl-8 sm:pl-3' readOnly value={resultData._id} />
							<button onClick={() => { copyToClip(resultData._id) }}>
								<BiCopy className='absolute left-4 top-1/2 -translate-y-1/2 text-gray-900' />
							</button>
						</div>
					</div>
				</div>
			</div>

			{/* Buttons */}
			<div className='flex justify-between gap-4 mt-2 flex-col sm:flex-row'>
				<Link to='#' className='w-full sm:w-1/2 bg-active text-gray-200 font-semibold py-3 rounded-lg flex items-center justify-center'>
					<Text tid='new-transfer' />
					<BiChevronLeft />
				</Link>
				<Link to='/transfer-history' className='w-full sm:w-1/2 border border-gray-200 text-gray-900 dark:text-white py-3 rounded-lg flex items-center justify-center'>
					<Text tid='transfer-history' />
					<BiChevronLeft />
				</Link>
			</div>
		</div>
	);
}
